const data1 = [
  {
    cat: 'library',
    name: 'D3',
    value: 30,
    icon: 'd3.svg',
    desc: `
				D3.js (or just D3 for Data-Driven Documents) is a JavaScript library for
				producing dynamic, interactive data visualizations in web browsers.
				It makes use of the widely implemented SVG, HTML5, and CSS standards.<br>
				This infographic you are viewing is made with D3.
			`,
  },
  {
    cat: 'library',
    name: 'Raphaël',
    value: 10,
    icon: 'raphael.svg',
    desc: `
				Raphaël is a cross-browser JavaScript library that draws Vector graphics for web sites.
				It will use SVG for most browsers, but will use VML for older versions of Internet Explorer.
			`,
  },
  {
    cat: 'library',
    name: 'ECharts',
    value: 30,
    icon: 'echarts.png',
    desc: `
      A Declarative Framework for Rapid Construction of Web-based Visualization
			`,
  },
  {
    cat: 'library',
    name: 'Recharts',
    value: 55,
    icon: 'recharts.svg',
    desc: `
				Composable charting library built on React components and SVG.
				Declarative API for line, bar, area, and pie charts—common in dashboards alongside shadcn/ui and Tailwind.
			`,
  },
  {
    cat: 'library',
    name: 'Lodash',
    value: 30,
    icon: 'lodash.svg',
    desc: `
				Lodash is a JavaScript library which provides <strong>utility functions</strong> for
				common programming tasks using the functional programming paradigm.`,


    // }, {
    // 	cat: 'library', name: 'Three.js', value: 40,
    // 	icon: 'threejs.png',
    // 	desc: `
    // 		Three.js allows the creation of GPU-accelerated 3D animations using
    // 		the JavaScript language as part of a website without relying on
    // 		proprietary browser plugins. This is possible thanks to the advent of WebGL.
    // 	`
  },
  {
    cat: 'library',
    name: 'Moment JS',
    value: 30,
    icon: 'momentjs.png',
    desc: `
				Handy and resourceful JavaScript library to parse, validate, manipulate, and display dates and times.
			`,
   
  },
  {
    cat: 'library',
    name: 'Redux',
    value: 60,
    icon: 'redux.svg',
    desc: `
				Redux is an open-source JavaScript library designed for managing
				application state. It is primarily used together with React for building user interfaces.
				Redux is inspired by Facebook’s Flux and influenced by functional programming language Elm.
			`,

  },
  {
    cat: 'framework',
    name: 'Bootstrap CSS',
    value: 50,
    icon: 'bootstrap.svg',
    desc: `
				Bootstrap is a free and open-source front-end web framework for designing websites
				and web applications. It contains HTML-and CSS-based design templates for typography,
				forms, buttons, navigation and other interface components, as well as optional JavaScript extensions.
			`,

  },
  {
    cat: 'framework',
    name: 'ExpressJS',
    value: 30,
    icon: 'expressjs.png',
    desc: `
				Express.js, or simply Express, is a JavaScript framework designed for building web applications and APIs.
				It is the de facto server framework for Node.js.
			`,
  },
  {
    cat: 'backend',
    name: 'KoaJS',
    value: 10,
    icon: 'koajs.svg',
    desc: `
				The advanced and improved version of ExpressJS, with leaner middlewares architecture
				thanks to the avent of ES6 generators.
			`,

  },
  {
    cat: 'framework',
    name: 'ReactJS',
    value: 60,
    icon: 'react.png',
    desc: `
				React (sometimes written React.js or ReactJS) is an open-source JavaScript framework maintained by Facebook for building user interfaces.
				React processes only user interface in applications and can be used in combination with other JavaScript libraries
				or frameworks such as Redux, Flux, Backbone...
			`,
  },
  {
    cat: 'framework',
    name: 'Vue',
    value: 100,
    icon: 'vue.png',
    desc: `
			`,
  },
  {
    cat: 'framework',
    name: 'Element UI',
    value: 80,
    icon: 'elementui.svg',
    desc: `
			`,

  },
  {
    cat: 'tooling',
    name: 'Google Chrome & Devtool',
    value: 70,
    icon: 'chrome-devtools.svg',
    desc: `
				<strong>Web development tools (devtool)</strong> allow web developers to test and debug their code.
				we use the one come with Google Chrome to debug our apps. It is one the the most powerful
				and sophisticated devtool available.
			`,
  },
  {
    cat: 'tooling',
    name: 'Jenkins CI',
    value: 30,
    icon: 'jenkins.png',
    desc: `
				Jenkins is an open source automation server. Jenkins helps to automate the non-human part of
				the whole software development process, with now common things like continuous integration,
				but by further empowering teams to implement the technical part of a Continuous Delivery.
			`,
  },
  {
    cat: 'tooling',
    name: 'Sublime Text 3',
    value: 40,
    icon: 'sublimetext.png',
    desc: `
				Sublime Text 3 is a powerful and cross-platform source code editor. It is well-known for
				introducing the concept of multi-cursor and lots of text editing command. Besides, its
				plugin ecosystem is very rich which allows enhancing productivity to the fullest.
			`,
  },
  {
    cat: 'tooling',
    name: 'Visual Studio Code',
    value: 60,
    icon: 'vscode.png',
    desc: `
				Visual Studio Code is a cross-platform source code editor developed by Microsoft.
				It includes support for debugging, embedded Git control, syntax highlighting,
				intelligent code completion, snippets, and code refactoring. Its extensions eco system is
				growing quickly and it is becoming the best Front End editors out there.
			`,
  },
  {
    cat: 'tooling',
    name: 'Performance Tooling',
    value: 30,
    icon: 'performance-tooling.svg',
    desc: `
				web performance is our top priority when development web sites and applications.
				We're practicing code optimization and Front End delivery optimization from day 1.
				To measure the resuslts, we use several tools to audit and benchmark our applications,
				including (but not limit to): Chrome devtool timeline & audit, Google PageSpeed Insights, Web Page Test, Website Grader...
			`,
    // }, {
    // 	cat: 'tooling', name: 'Yeoman generator for Nau Workflow', value: 20,
    // 	icon: 'yeoman.png',
    // 	desc: `
    // 		Yeoman is an open source, command-line interface set of tools mainly used to generate
    // 		structure and scaffolding for new projects, especially in JavaScript and Node.js.
    // 		we have developed a Yeoman generator that help quickly set up new projects aligned with
    // 		Nau's conventions and standards.
    // 	`
    // }, {
    // 	cat: 'tooling', name: 'live-server', value: 30,
    // 	icon: 'live-server',
    // 	desc: `
    // 		A Node.js-based developer web server for quickly test apps and web pages with some
    // 		magic of 'auto-reload' on the browser.
    // 	`
  },
  {
    cat: 'tooling',
    name: 'PostCSS',
    value: 30,
    icon: 'postcss.svg',
    desc: `
				PostCSS is a software development tool that uses JavaScript-based plugins to automate routine CSS operations.<br>
				We use PostCSS mainly for auto-vendor-prefixing, but very soon we'll use it for NextCSS compilation.
			`,


  },
  {
    cat: 'backend',
    name: 'MongoDB',
    value: 40,
    icon: 'mongodb.png',
    desc: `
				The de-facto Database solution for JavaScript and Node.js applications. It is a light weight,
				high performance NoSQL database and can be used for small and large websites.
			`,
  },
  {
    cat: 'backend',
    name: 'NodeJS',
    value: 80,
    icon: 'nodejs.svg',
    desc: `
				Node.js is a cross-platform JavaScript runtime environment.
				Node.js allows creation of high performance and high concurrency websites with smaller footprint compared to
				other server-side solution. Node.js ecosystem is growing very fast and is trusted by a lot of big companies who
				are adopting it to enhance current products as well as for new ones.
			`,
  },
  {
    cat: 'platform',
    name: 'Docker Platform',
    value: 10,
    icon: 'docker.svg',
    desc: `
				Docker is an open-source project that automates the deployment of applications inside software containers.
				we're still learning this technology to later facilitate easy web app deployments.
			`,
  },
  {
    cat: 'platform',
    name: 'AWS',
    value: 70,
    icon: 'aws.svg',
    desc: `
				Amazon Web Services—cloud platform for hosting and scaling modern frontends.
				Common pieces include S3 + CloudFront for static sites, Amplify for CI/CD, Lambda/API Gateway for serverless APIs,
				and Cognito for auth behind React and Next.js apps.
			`,
  },
  {
    cat: 'language',
    name: 'HTML5 & CSS3',
    value: 100,
    icon: 'html5-css3.png',
    desc: `
				The languages of the Web Front End. they are in our blood and with them we can build
				world-class websites with any kind of visual effects or designs requested.
			`,
  },
  {
    cat: 'language',
    name: 'JavaScript',
    value: 100,
    icon: 'javascript.png',
    desc: `
				JavaScript is the heart of modern Web front end development and essential element of any Single Page
				Applications. In Nau, we invest a good deal in training developers to have good control of this universal language
				and now caplable of developing full stack websites with only JavaScript.
			`,
  },
  {
    cat: 'language',
    name: 'ECMASCRIPT',
    value: 100,
    icon: 'es6.png',
    desc: `
      ECMAScript is a scripting-language specification standardized by Ecma International. It was created to standardize JavaScript to help foster multiple independent implementations. JavaScript has remained the most widely used implementation of ECMAScript since the standard was first published, with other implementations including JScript and ActionScript.[2] ECMAScript is commonly used for client-side scripting on the World Wide Web, and it is increasingly being used for writing server applications and services using Node.js..
			`,
  },
  {
    cat: 'language',
    name: 'CSS Next',
    value: 10,
    icon: 'cssnext.png',
    desc: `
				The CSS language specs of the future but with the help of PostCSS (like Babel for ES6),
				we can use CSS Next today.
			`,
  },
  {
    cat: 'language',
    name: 'GraphQL',
    value: 50,
    icon: 'graphql.svg',
    desc: `
				GraphQL is a query language and runtime for APIs, letting clients request exactly the fields they need.
				Pairs well with React via Apollo Client or Relay, and reduces over-fetching compared to REST.
			`,
  },
  {
    cat: 'language',
    name: 'SASS (SCSS flavor)',
    value: 70,
    icon: 'sass.png',
    desc: `
				This is our main CSS preprocessor language helping us lay structured foundation to CSS as well
				as assisting on writing more convenient BEM anotations.
			`,
  },
  {
    cat: 'language',
    name: 'TypeScript',
    value: 60,
    icon: 'typescript.png',
    desc: `
				The strict-typing flavor of ECMAScript, always requires a compiler to compile to vanilla JavaScript
				but the type checking and other syntactical sugar are exceptional. Right now, we only use it for
				Angular 2 projects when needed.
			`,
    // }, {
    // 	cat: 'workflow', name: 'code.naustud.io', value: 100,
    // 	icon: 'naustudio.svg',
    // 	desc: `
    // 		A set of guidelines, presets, configs and stadard documentation for Nau developers.
    // 		Please visit the document site at: <a href='http://code.naustud.io' target='_blank'>code.naustud.io</a>
    // 	`
    // }, {
    // 	cat: 'workflow', name: 'Mobile First', value: 100,
    // 	icon: 'Mobile First',
    // 	desc: `
    // 		This is one of our most important principle for web and mobile development.
    // 		More details will be discussed in blog later.
    // 	`
  },
  {
    cat: 'workflow',
    name: 'BabelJS',
    value: 50,
    icon: 'babel.png',
    desc: `
				The de-facto tool to work with ECMAScript 6 and ReactJS nowadays.
			`,
    // },
    /*{
			cat: 'workflow', name: 'Browserify', value: 10,
			icon: '',
		},*/
    // {
    // 	cat: 'workflow', name: 'CSS BEM Notation', value: 70,
    // 	icon: 'CSS BEM Notation',
    // 	desc: `
    // 		Our naming standard for CSS, which enhance collaboration, documentation and reusability of
    // 		CSS rules.
    // 	`
  },
  {
    cat: 'workflow',
    name: 'Front End Code Guide',
    value: 30,
    icon: 'front-end-code-guide.svg',
    desc: `
				Based on an existing best practice document for HTML and CSS. We're adopting it as our standards
				and guideline.
			`,
  },
  {
    cat: 'workflow',
    name: 'ESLint',
    value: 20,
    icon: 'eslint.svg',
    desc: `
				The tool to check and validate JavaScript code when we develop and prevent potential issues with code.
			`,
  },
  {
    cat: 'workflow',
    name: 'Gitflow Workflow',
    value: 70,
    icon: 'gitflow.svg',
    desc: `
				Our code version control tool is Git, and Gitflow is one of its workflow standard which
				ensure good collaboration and avoid conflict-resolving efforts. For more info, visit: code.naustud.io
			`,
  },


  {
    cat: 'workflow',
    name: 'Webpack',
    value: 80,
    icon: 'webpack.svg',
    desc: `
				A module bundler library that is becoming de-facto tool to use in ReactJS or SPA apps nowadays.
			`,

  },
  {
    cat: 'legacy',
    name: 'jQuery',
    value: 50,
    icon: 'jquery.png',
    desc: `
				Deprecated, because <a href='http://youmightnotneedjquery.com/' target='_blank'>youmightnotneedjquery.com</a>
			`,
  },

  {
    cat: 'library',
    name: 'Ant Design',
    value: 30,
    icon: 'ant-design.svg',
    desc: `

			`,
  },
  {
    cat: 'library',
    name: 'Material Design',
    value: 30,
    icon: 'material.png',
    desc: `

			`,
  },
  {
    cat: 'library',
    name: 'shadcn/ui',
    value: 65,
    icon: 'shadcn-ui.svg',
    desc: `
				Copy-paste React components built on Radix UI and Tailwind CSS—not a traditional npm UI kit.
				Widely used with Next.js for accessible, themeable UIs and pairs naturally with v0 and AI-generated layouts.
			`,
  },
  {
    cat: 'framework',
    name: 'Tailwind CSS',
    value: 70,
    icon: 'tailwindcss.svg',
    desc: `
				Utility-first CSS framework for rapid UI development with design tokens, responsive variants, and dark mode.
				Standard styling layer for modern React stacks, often combined with shadcn/ui and PostCSS in production apps.
			`,
  },
  {
    cat: 'framework',
    name: 'GSAP',
    value: 30,
    icon: 'gsap.svg',
    desc: `

			`,
  },
  {
    cat: 'language',
    name: 'PHP',
    value: 30,
    icon: 'php.svg',
    desc: `

			`,
  },
  {
    cat: 'library',
    name: 'Vercel',
    value: 75,
    icon: 'vercel.svg',
    desc: `
				Vercel provides the developer tools and cloud infrastructure to build, scale, and secure a faster, more personalized web.
			`,
  },
  {
    cat: 'ai library',
    name: 'LangChain.js',
    value: 65,
    icon: 'langchain.svg',
    desc: `
				Framework for composing LLM apps in JavaScript: chains, agents, retrievers, and memory.
				Common in RAG dashboards, chatbots, and Node.js backends that power frontends.
			`,
  },
  {
    cat: 'ai library',
    name: 'Transformers.js',
    value: 55,
    icon: 'transformers-js.svg',
    desc: `
				Run Hugging Face transformer models in the browser with WebGPU/WASM—no server round-trip.
				Enables on-device inference for embeddings, classification, and generative tasks in web apps.
			`,
  },
  {
    cat: 'ai library',
    name: 'CopilotKit',
    value: 50,
    icon: 'copilotkit.png',
    desc: `
				React components and hooks to embed in-app AI copilots with shared state, actions, and generative UI.
				Bridges your product UI and LLM backends with a cohesive developer experience.
			`,
  },
  {
    cat: 'ai library',
    name: 'assistant-ui',
    value: 45,
    icon: 'assistant-ui.svg',
    desc: `
				Composable React primitives for AI chat: message threads, streaming, tool results, and composer UX.
				Built for production chat interfaces that feel native to modern design systems.
			`,
  },
  {
    cat: 'ai library',
    name: 'LlamaIndex.TS',
    value: 45,
    icon: 'llamaindex.png',
    desc: `
				Data framework for LLM apps: document loaders, chunking, vector indexes, and query engines in TypeScript.
				Powers retrieval-augmented generation (RAG) flows behind many AI-first frontends.
			`,
  },
  {
    cat: 'ai library',
    name: 'OpenAI API',
    value: 80,
    icon: 'openai.svg',
    desc: `
				REST and streaming APIs for GPT models, embeddings, images, and speech—wired into countless SPAs and SSR apps.
				Often paired with the Vercel AI SDK or custom fetch layers for chat and agent features.
			`,
  },
  {
    cat: 'ai library',
    name: 'TensorFlow.js',
    value: 40,
    icon: 'tensorflow.svg',
    desc: `
				Train and run machine learning models directly in the browser or in Node.js with WebGL/WebGPU acceleration.
				Still relevant for client-side vision, gesture, and custom model inference alongside LLM stacks.
			`,
  },
  {
    cat: 'ai library',
    name: 'ONNX Runtime Web',
    value: 35,
    icon: 'onnx.svg',
    desc: `
				High-performance inference for ONNX models in the browser via WASM and WebGPU.
				Useful when shipping optimized models to the edge without a Python runtime.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'Cursor',
    value: 85,
    icon: 'cursor.svg',
    desc: `
				AI-native code editor (VS Code fork) with inline edits, codebase chat, and multi-file refactors.
				Central to how many frontend teams ship UI, tests, and design-system changes today.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'GitHub Copilot',
    value: 80,
    icon: 'github-copilot.svg',
    desc: `
				Inline code completion and chat inside VS Code, JetBrains, and Neovim, trained on public repositories.
				Accelerates component scaffolding, hooks, and test generation across React and Vue codebases.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'v0',
    value: 65,
    icon: 'v0.svg',
    desc: `
				Vercel's generative UI tool: describe interfaces in natural language and get shadcn/Tailwind React code.
				Shortens the path from prompt to production-ready components and page layouts.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'MCP',
    value: 70,
    icon: 'mcp.svg',
    desc: `
				Model Context Protocol—open standard for connecting LLM clients to tools, APIs, and data sources.
				Emerging backbone for agentic IDEs and custom frontends that orchestrate external capabilities.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'Bolt.new',
    value: 55,
    icon: 'bolt.svg',
    desc: `
				StackBlitz AI app builder: prompt-to-full-stack in the browser with instant preview and deploy.
				Popular for rapid prototyping of React/Vite frontends with integrated AI assistance.
			`,
  },
  {
    cat: 'ai tooling',
    name: 'Windsurf',
    value: 50,
    icon: 'windsurf.svg',
    desc: `
				AI IDE from Codeium with flows, cascade edits, and deep codebase awareness for web projects.
				Competes with Cursor for agentic refactors across large frontend monorepos.
			`,
  },
];

export default data1;
